/* istanbul ignore file */
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
